import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { Office } from "./office/Office.js";
import { Install } from "./install/Install.js";
import "./styles.css";

const host = document.getElementById("root");
if (!host) throw new Error("#root is missing from index.html");

// three entries, one bundle: the shop, /office for the warehouse and the driver, /install for phones
const path = window.location.pathname.replace(/\/+$/, "");
const Root = path === "/office" ? Office : path === "/install" || path === "/office/install" ? Install : App;

// The office is its own home-screen app: own manifest, own icon, opens on /office.
// Both pages ship in one index.html, so the manifest link is swapped before the
// browser reads it, and the title is what iOS will write under the icon.
const forOffice = path.startsWith("/office") || (path === "/install" && new URLSearchParams(window.location.search).get("for") === "office");
if (forOffice) {
  document.querySelector('link[rel="manifest"]')?.setAttribute("href", "/office.webmanifest");
  document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute("content", "Moo Moo Office");
  document.querySelector('link[rel="apple-touch-icon"]')?.setAttribute("href", "/icon-office-192.png");
  for (const meta of document.querySelectorAll('meta[name="theme-color"]')) meta.setAttribute("content", "#0d2a55");
  document.title = "Moo Moo Office";
}

// the shell works offline and from the home screen; the API is never cached
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

createRoot(host).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
